import { DocumentTextIcon } from '@heroicons/react/24/outline';

// Placeholder only - there is no file storage backend for orthodontist
// organizations yet (see practice's PracticeFilesSection for the real thing).
export function OrthodontistFilesSection() {
    return (
        <div className="bg-white border border-gray-200 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.06)] flex flex-col items-center justify-center gap-2 py-16 shrink-0">
            <DocumentTextIcon className="h-8 w-8 text-gray-300" />
            <p className="text-sm font-semibold text-gray-500">Coming soon</p>
            <p className="text-sm text-gray-400 text-center max-w-xs">
                File storage for orthodontist organizations is coming soon.
            </p>
        </div>
    );
}
